<script setup lang="ts">
type Article = {
  Id: string;
  Title: string;
  KnowledgeArticleId: string;
};

interface Props {
  searchResults?: Article[];
  currentArticleId?: string;
}

withDefaults(defineProps<Props>(), {
  searchResults: () => [],
  currentArticleId: undefined,
});
</script>

<template>
  <div v-if="searchResults.length > 0" class="showdow-md bg-accent-25 sticky top-6 rounded-2xl px-4 py-5">
    <TypographyTitle as="h3" size="sm" class="mb-4">Related Articles</TypographyTitle>

    <ul class="list-disc space-y-2 pl-6">
      <li v-for="article in searchResults.slice(0, 5)" :key="article.Id">
        <a
          :href="`/student-experience/academic-services/bruin-support/bruin-support-articles/${article.KnowledgeArticleId}/`"
          class="text-primary underline"
        >
          {{ article.Title }}
        </a>
      </li>
    </ul>
  </div>
</template>
